const loadingMessages = {
  "login": "Please Wait! Logging in...",
  "codeConvert": "Conversion Started... ⏳ Hang tight! This process may take a moment. Please wait and remain on the page.",
  "iteration": "Started iteration ",
  "common": "⏳ This process may take a moment. Please wait and remain on the page."
}

export default loadingMessages